export const UNDER_THE_DOOR_ID = 617
export const LEAVE_PARCEL_RECEPTION = 824
export const HUNG_PARCEL_INSIDE = 618
export const OTHER_PACKAGE_LEAVING_OPTION = 626
